import { Divider, Tab, Tabs, Theme, useMediaQuery } from "@material-ui/core";
import People from "@material-ui/icons/People";
import { List } from "@react-admin/ra-rbac";
import { Fragment, useCallback, useEffect, useState } from "react";
import { AutocompleteInput, Create, Datagrid, Edit, ReferenceField, ReferenceInput, required, SimpleForm, SimpleList, TextField, TextInput, useAuthProvider, useRecordContext, useRedirect, useTranslate } from "react-admin";
import { Route } from 'react-router';
import { AvatarField, CustomTitle, Legend } from "../common/components";
import { filter, isCreate } from "../common/components/utils/fn";
import { UserTeamList } from "./UserTeam";

export const TeamIcon = People;

export const TeamList = props => {
    const authProvider = useAuthProvider();
    const [security, setSecurity] = useState(null);
    useEffect(() => {
        const role = authProvider.getRole();
        if (role === "teamManager") {
            setSecurity({ managerId: authProvider.getId() })
        }
    }, [authProvider]);
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
    return (
        <List {...props} sort={{ field: 'name', order: "ASC" }}
            filter={security}
            filters={[
                <TextInput source="name" alwaysOn />,
                <TextInput source="description" />
            ]}>
            {isSmall
                ? <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.description}
                    tertiaryText={
                        () =>
                            <ReferenceField source="managerId" reference="user">
                                <AvatarField source="fullname" className="right" />
                            </ReferenceField>
                    }
                />
                : <Datagrid rowClick="edit">
                    <TextField source="name" />
                    <TextField source="description" />
                    <ReferenceField source="managerId" reference="user">
                        <AvatarField source="fullname" />
                    </ReferenceField>
                </Datagrid>}
        </List>
    );
};

const TeamDetailsForm = (props) => <SimpleForm {...props}>
    {isCreate() && <Legend />}
    <TextInput source="name" validate={[required()]} />
    <TextInput source="description" multiline />
    <ReferenceInput source="managerId" reference="user" validate={[required()]} filter={{ role: filter(null, "productor", "_neq") }}>
        <AutocompleteInput optionText="fullname" />
    </ReferenceInput>
</SimpleForm>;

const TeamEditForm = (props) => {
    const redirect = useRedirect();
    const record = useRecordContext();
    const id = record?.id;
    const translate = useTranslate();
    const path = `/team/${id}`
    const handleChange = useCallback((event: React.ChangeEvent<{}>, value: string) => {
        const v = (value === "details" ? path : `${path}/${value}`)
        redirect(v);
    }, [path, redirect]);
    return <Fragment>
        <Tabs value={props.tab} onChange={handleChange}>
            <Tab label={translate("resources.details")} value="details" />
            <Tab label={translate("resources.team.fields.members")} value="productors" />
        </Tabs>
        <Divider />
        <Route exact path="/team/:id">
            <TeamDetailsForm {...props} />
        </Route>
        <Route path="/team/:id/productors">
            <UserTeamList className="padding" teamId={id} />
        </Route>
    </Fragment >
};

export const TeamEdit = ({ tab = "details", ...props }) =>
    <Edit {...props} title={<CustomTitle title="team" />}>
        <TeamEditForm tab={tab} />
    </Edit>;

export const TeamCreate = props =>
    <Create {...props}>
        <TeamDetailsForm />
    </Create>;